var $2d53ea0c1be61530$exports = {};
$2d53ea0c1be61530$exports = {
    "help": `Aiuto`,
    "info": `Informazioni`
};


export {$2d53ea0c1be61530$exports as default};
//# sourceMappingURL=it-IT.mjs.map
